/**
 * ScrollToTop Component
 * Resets scroll position to top on mount and route changes
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    // Disable browser scroll restoration on refresh
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // Scroll to top on initial page load
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default ScrollToTop;
